import type { SVGProps } from 'react';

export default function FaceLove(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0795 6.09171C15.5188 5.6361 16.2312 5.6361 16.6705 6.09171L17 6.43342L17.3295 6.09171C17.7688 5.6361 18.4812 5.6361 18.9205 6.09171C19.3598 6.54732 19.3598 7.28601 18.9205 7.74162L17.7955 8.90829C17.3562 9.3639 16.6438 9.3639 16.2045 8.90829L15.0795 7.74162C14.6402 7.28601 14.6402 6.54732 15.0795 6.09171Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11C10.5 11.2761 10.2761 11.5 10 11.5C9.72386 11.5 9.5 11.2761 9.5 11C9.5 10.7239 9.72386 10.5 10 10.5C10.2761 10.5 10.5 10.7239 10.5 11Z"
        stroke="currentColor"
      />
      <path
        d="M14.5 11C14.5 11.2761 14.2761 11.5 14 11.5C13.7239 11.5 13.5 11.2761 13.5 11C13.5 10.7239 13.7239 10.5 14 10.5C14.2761 10.5 14.5 10.7239 14.5 11Z"
        stroke="currentColor"
      />
      <path
        d="M9.75 14.75C9.75 14.75 10.5 15.75 12 15.75C13.5 15.75 14.25 14.75 14.25 14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
